import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '@app/shared';
import { NavList } from '@entity/navigation';

@Pipe({
  name: 'roleFilter'
})
export class RoleFilterPipe implements PipeTransform {
  constructor(private auth: AuthService) {}  
  transform(value: NavList[]): any {
    if (value) {           
      return value.reduce((accumulator, parent) => {
        if (parent.freeze) {
          const dats = parent.child.filter(child =>
            child.freeze
          );
          if (dats) {
            const dft = JSON.parse(JSON.stringify(parent));
            dft.child = dats;
            accumulator.push(dft);
          }
        }
        return accumulator;
      }, []);
    }
    return value;
  }
}
